// ============================================================================
// DIJKSTRA - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'dijkstra',
  name: 'Dijkstra',
  category: 'Graphs',
  complexity: {
    time: 'O((V + E) log V)',
    space: 'O(V)'
  },
  description: 'A single-source shortest path algorithm for graphs with non-negative edge weights. It uses a priority queue to greedily select the vertex with the minimum distance from the source and relaxes its outgoing edges.'
};
